(function () {
  const onReady = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  onReady(function () {
    const sliderSel = '.skin-improvents-slider';
    const sliderEl = document.querySelector(sliderSel);

    if (!sliderEl) return;

    const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

    function equalizeSlides() {
      const slides = sliderEl.querySelectorAll('.swiper-slide');
      if (!slides.length) return;

      if (!isDesktop()) {
        // Mobile: Use fixed height from CSS, don't calculate dynamically
        slides.forEach((s) => {
          s.style.height = '';
          const box = s.querySelector('.improvement-box');
          if (box) box.style.height = '';
        });
        sliderEl.style.minHeight = '';
        return;
      }

      // Desktop only: Calculate dynamic heights
      // Reset before measuring
      slides.forEach((s) => {
        s.style.height = '100%';
        const box = s.querySelector('.improvement-box');
        if (box) box.style.height = '100%';
      });
      sliderEl.style.minHeight = '';

      let max = 0;
      slides.forEach((s) => {
        const h = s.offsetHeight;
        if (h > max) max = h;
      });

      slides.forEach((s) => {
        s.style.height = max + 'px';
        const box = s.querySelector('.improvement-box');
        if (box) box.style.height = '100%';
      });

      sliderEl.style.minHeight = max + 'px';
    }

    // Simple debounce (no lodash)
    let t;
    const debouncedEqualize = () => {
      clearTimeout(t);
      t = setTimeout(equalizeSlides, 120);
    };

    const swiper = new Swiper(sliderSel, {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 1,
      autoplay: { delay: 3000, disableOnInteraction: false },
      breakpoints: {
        375: { slidesPerView: 1.3, spaceBetween: 0 },
        768: { slidesPerView: 1.3, spaceBetween: 0 },
        1024: { slidesPerView: 1.5 }
      },
      on: {
        init: equalizeSlides,
        imagesReady: equalizeSlides,
        resize: debouncedEqualize,
        slideChangeTransitionEnd: debouncedEqualize
      }
    });

    // In case images load after Swiper fired its events
    window.addEventListener('load', equalizeSlides);
  });
})();
